module.exports = __webpack_public_path__ + "static/media/solutions__lead_perf.49e10771.png";